import { NodeWrapper } from "./NodeWrapper";
import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { TouchAppOutlined as TouchApp, ViewCarouselOutlined } from '@mui/icons-material';
import { mkHeaderStyle, HEADER_ICON_STYLE, HEADER_TEXT_STYLE, mkInputHandleStyle, mkOutputHandleStyle } from "./nodeStyles";
import { i18n } from "../../../translate/i18n";

import { Tooltip as CoreTooltip, IconButton as CoreIconButton } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { HelpOutline as HelpOutlineIcon } from '@mui/icons-material';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#1e293b',
    color: '#f8fafc',
    maxWidth: 380,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #334155',
    padding: '12px 14px',
    borderRadius: '8px',
    fontFamily: "'Inter', 'Roboto', sans-serif",
    lineHeight: 1.5,
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.5), 0 4px 6px -2px rgba(0, 0, 0, 0.3)',
  },
  arrow: {
    color: '#1e293b',
  },
}))(CoreTooltip);

export default memo(({ data, isConnectable, id, selected }) => {
  const cards = data.cards || [];
  
  return (
    <NodeWrapper id={id} selected={selected} color="#3F51B5">
      {/* Handle de Entrada */}
      <Handle type="target" position="left" style={{ ...mkInputHandleStyle("#3F51B5"), left: "-12px" }} isConnectable={isConnectable} />

      {/* Header del Nodo */}
      <div style={mkHeaderStyle("#3F51B5")}>
        <ViewCarouselOutlined style={HEADER_ICON_STYLE} />
        <div style={HEADER_TEXT_STYLE}>{data.name || "Carrusel"}</div>
        <HtmlTooltip 
          title={
            <React.Fragment>
              <div dangerouslySetInnerHTML={{ __html: i18n.t("flowBuilder.tooltips.carousel.body") }} />
            </React.Fragment>
          }
          placement="top"
          arrow
        >
          <CoreIconButton size="small" style={{ padding: '4px', marginLeft: 'auto', color: 'rgba(255,255,255,0.85)' }}>
            <HelpOutlineIcon style={{ fontSize: '16px' }} />
          </CoreIconButton>
        </HtmlTooltip>
      </div>

      <div style={{ padding: "10px 12px 6px 12px" }}>
        <div style={{
          color: "#475569",
          fontSize: "12px",
          backgroundColor: "#fdf2f8",
          padding: "7px 9px",
          borderRadius: "6px",
          border: "1px solid #e0e7ff",
          marginBottom: "10px"
        }}>
          {data.body || <span style={{ color: "#94a3b8", fontStyle: "italic" }}>Cuerpo del mensaje...</span>}
        </div>

        <div style={{
          fontSize: "10px",
          fontWeight: "600",
          color: "#64748b",
          marginBottom: "4px",
          textTransform: "uppercase",
          letterSpacing: "0.5px"
        }}>
          Tarjetas ({cards.length}/10)
        </div>

        {cards.map((card, cIdx) => (
          <div key={card.id || cIdx} style={{
            position: "relative",
            marginBottom: "6px",
            backgroundColor: "#f8fafc",
            border: `1px solid #e2e8f0`,
            borderRadius: "6px",
            padding: "5px 8px"
          }}>
            <div style={{ fontSize: "11px", fontWeight: "bold", color: "#334155", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {card.headerText || `Tarjeta ${cIdx + 1}`}
            </div>
            
            {card.buttons && card.buttons.map((btn, bIdx) => (
              <div key={btn.id || bIdx} style={{ position: "relative", marginTop: "4px" }}>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#fff",
                  border: `1px solid #e0e7ff`,
                  borderRadius: "4px",
                  padding: "3px 6px",
                  fontSize: "10px",
                  color: "#3F51B5",
                  fontWeight: "500"
                }}>
                  <TouchApp sx={{ width: "10px", height: "10px", marginRight: "3px" }} />
                  <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {btn.text || `Botón ${bIdx + 1}`}
                  </span>
                </div>
                {/* Cable de salida por cada botón */}
                <Handle type="source" position="right" id={`btn-${btn.payload || btn.text || btn.id}`} style={{ ...mkOutputHandleStyle("#3F51B5"), right: "-34px" }} isConnectable={isConnectable} />
              </div>
            ))}
          </div>
        ))}
      </div>

      <div style={{
          marginTop: "4px",
          borderTop: "1px dashed #e2e8f0",
          padding: "10px 12px 10px 12px"
      }}>
          <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
              <div style={{ fontSize: "11px", color: "#64748b", fontWeight: "600", paddingLeft: "26px" }}>
                  Respuesta Libre / Fallback
              </div>
              <Handle type="source" position="right" id="fallback" style={{ ...mkOutputHandleStyle("#ef4444"), right: "-24px" }} isConnectable={isConnectable} />
          </div>
      </div>
    </NodeWrapper>
  );
});
